import $ from 'jquery';

export default function isInViewport(element) {
	let win = $(window);
	let viewport = {
		left: win.scrollLeft(),
		top: win.scrollTop(),
	};
	viewport.bottom = viewport.top + win.height();
	viewport.right = viewport.left + win.width();
	var bounds = element.offset();
	bounds.bottom = bounds.top + element.outerHeight();
	bounds.right = bounds.left + element.outerWidth();
	return !(
		viewport.bottom < bounds.top ||
		viewport.left > bounds.right ||
		viewport.right < bounds.left ||
		viewport.top > bounds.bottom
	);
}
